var _path, _mask, _path2, _path3, _path4, _path5, _line, _line2, _path6, _line3, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _rect2, _path7, _circle, _ellipse7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 301,
    viewBox: "0 0 574 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.506 156.561C421.506 232.247 360.151 293.602 284.465 293.602C208.78 293.602 147.424 232.247 147.424 156.561C147.424 80.8757 208.78 19.5205 284.465 19.5205C360.151 19.5205 421.506 80.8757 421.506 156.561Z",
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3269_335",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.558 294.353C360.615 294.303 422.256 232.631 422.256 156.562C422.256 85.7331 368.814 27.3861 300.054 19.6436H280.977V294.31C282.106 294.338 283.237 294.352 284.372 294.353C284.403 294.353 284.434 294.353 284.465 294.353C284.496 294.353 284.527 294.353 284.558 294.353Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.558 294.353C360.615 294.303 422.256 232.631 422.256 156.562C422.256 85.7331 368.814 27.3861 300.054 19.6436H280.977V294.31C282.106 294.338 283.237 294.352 284.372 294.353C284.403 294.353 284.434 294.353 284.465 294.353C284.496 294.353 284.527 294.353 284.558 294.353Z",
    fill: "#FD4C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.558 294.353L284.558 295.853L284.559 295.853L284.558 294.353ZM300.054 19.6436L300.222 18.153L300.138 18.1436H300.054V19.6436ZM280.977 19.6436V18.1436H279.477V19.6436H280.977ZM280.977 294.31H279.477V295.773L280.94 295.809L280.977 294.31ZM284.372 294.353L284.371 295.853H284.372V294.353ZM420.756 156.562C420.756 231.803 359.786 292.803 284.557 292.853L284.559 295.853C361.444 295.802 423.756 233.459 423.756 156.562H420.756ZM299.886 21.1341C367.896 28.7922 420.756 86.5052 420.756 156.562H423.756C423.756 84.9611 369.732 25.9799 300.222 18.153L299.886 21.1341ZM280.977 21.1436H300.054V18.1436H280.977V21.1436ZM282.477 294.31V19.6436H279.477V294.31H282.477ZM284.373 292.853C283.25 292.852 282.131 292.838 281.014 292.81L280.94 295.809C282.08 295.837 283.224 295.852 284.371 295.853L284.373 292.853ZM284.465 292.853C284.45 292.853 284.435 292.853 284.419 292.853C284.404 292.853 284.388 292.853 284.372 292.853V295.853C284.387 295.853 284.402 295.853 284.418 295.853C284.433 295.853 284.449 295.853 284.465 295.853V292.853ZM284.558 292.853C284.542 292.853 284.526 292.853 284.511 292.853C284.495 292.853 284.48 292.853 284.465 292.853V295.853C284.481 295.853 284.497 295.853 284.512 295.853C284.528 295.853 284.543 295.853 284.558 295.853V292.853Z",
    fill: "#101010",
    mask: "url(#path-2-inside-1_3269_335)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26746 296.969C6.26746 143.806 130.821 19.6436 284.465 19.6436",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555.686 293.481C555.686 142.245 434.257 19.6436 284.465 19.6436",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 552.54,
    y1: 293.139,
    x2: 280.447,
    y2: 21.0457,
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 280.447,
    y1: 292.078,
    x2: 552.54,
    y2: 19.9851,
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26727 292.608L280.669 20.2071",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.01221,
    y1: 293.603,
    x2: 351.617,
    y2: 293.603,
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeDasharray: "2 3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 281.727,
    y: 20.3936,
    width: 273.209,
    height: 273.209,
    stroke: "#101010",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.686,
    cy: 294.353,
    rx: 6.10465,
    ry: 6.10465,
    fill: "#101010"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.623,
    cy: 156.998,
    rx: 6.10465,
    ry: 6.10465,
    transform: "rotate(90 143.623 156.998)",
    fill: "#101010"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.26743,
    cy: 294.353,
    rx: 6.10465,
    ry: 6.10465,
    fill: "#101010"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.977,
    cy: 19.6427,
    rx: 6.10465,
    ry: 6.10465,
    fill: "#101010"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.977,
    cy: 294.353,
    rx: 6.10465,
    ry: 6.10465,
    fill: "#101010"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.331,
    cy: 156.998,
    rx: 6.10465,
    ry: 6.10465,
    transform: "rotate(90 418.331 156.998)",
    fill: "#101010"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.39,
    y: 127.66,
    width: 52.5698,
    height: 52.5698,
    fill: "#FFC9B3",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.963 161.746C146.995 164.782 147.026 167.818 144.021 170.823C141.016 173.828 134.959 175.284 130.358 170.683C125.757 166.082 127.213 160.025 130.218 157.02C134.725 152.513 140.046 153.326 146.885 154.155C153.725 154.985 159.046 155.798 163.553 151.291C166.558 148.286 168.014 142.229 163.413 137.628C158.812 133.027 152.755 134.483 149.75 137.488C146.745 140.493 146.792 145.047 146.808 146.565",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 555.25,
    cy: 19.207,
    r: 18,
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.686,
    cy: 19.6427,
    rx: 6.10465,
    ry: 6.10465,
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5856e2b58373d1b368fe004483d7953c.svg";
export { ForwardRef as ReactComponent };